import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { toast } from '@sales-center/components'
import { store } from '@user/store/store'
import { ExternalLinkedApplication } from '@user/store/authorization'
import {
  externalProductPestPacName,
  objectToQueryString,
} from '@sales-center/common'

export async function launchFormManager() {
  const response = await get(`${ServiceConfig.baseAPIUrl}/Proposals/url`)

  if (response.ok) {
    const json = await response.json()
    const url: string = json
    window.open(url, '_blank')
  } else {
    toast.error('Failed to launch Form Manager.')
  }
}

async function launchWWAnalytics() {
  const extApps = store.getState().userState.user.externalApplications

  const qstring = objectToQueryString({
    allowedDataSources: [
      'Sales Center',
      ...extApps.map((x) => getAppName(x.name)),
    ],
  })

  const response = await get(
    `${ServiceConfig.baseAPIUrl}/reports/url?${qstring}`,
  )

  if (response.ok) {
    const url: string = await response.json()
    window.open(url, '_blank')
  } else {
    toast.error('Failed to launch Reports')
  }
}

function getAppAbbreviation(appName: string) {
  switch (appName) {
    case 'Lead Management':
      return 'LM'
    case externalProductPestPacName:
      return 'PP'
    case 'Sales Center':
      return 'SC'
    case 'Reports':
      return 'R'
    default:
      return appName.charAt(0).toUpperCase()
  }
}

function getAppName(appName: string) {
  switch (appName) {
    case externalProductPestPacName:
      return 'PestPac'
    default:
      return appName
  }
}

function getAppClick(app: ExternalLinkedApplication) {
  const { name, appUrl } = app

  switch (name) {
    case 'Forms Manager':
      return launchFormManager
    case 'PestPac':
      return () =>
        window.open(
          `${appUrl}${ServiceConfig.coreProduct.landingPage}`,
          '_blank',
        )
    case 'Reports':
      return launchWWAnalytics
    default:
      return () => window.open(appUrl, '_blank')
  }
}

export function getAppData(app: ExternalLinkedApplication) {
  return {
    appName: getAppName(app.name),
    appAbbreviation: getAppAbbreviation(app.name),
    onClick: getAppClick(app),
  }
}
